import {
  KuxProgramType,
  KuxLinearType,
  KuxLinkAsAssetType,
  KuxMovieType,
  KuxEpisodeType,
  KuxSeriesType,
  KuxMediaAssetType,
  KuxPerson,
  KuxLogo,
  KuxPackage,
  getLinearById,
} from '@kaltura-ott/tvpil';
import { lastValueFrom } from 'rxjs';
import { container } from 'tsyringe';

import { assertPresence } from '../../utils/error-handling';
import type { DmsStore } from '../dms/dms-store';
import type { LinearRepository } from '../linearRepository/linear-repository';

import { EntitiesType } from './entities.types';
import { Episode } from './Episode';
import type { Linear } from './Linear';
import { LinkAsAsset } from './LinkAsAsset';
import { Logo } from './Logo';
import { Movie } from './Movie';
import { Package } from './Package';
import { Person } from './Person';
import { Program } from './Program';
import { Series } from './Series';

export function creatorEntityStore(kuxAsset: KuxProgramType): Program;
export function creatorEntityStore(kuxAsset: KuxLinearType): Linear;
export function creatorEntityStore(kuxAsset: KuxLinkAsAssetType): LinkAsAsset;
export function creatorEntityStore(kuxAsset: KuxMovieType): Movie;
export function creatorEntityStore(kuxAsset: KuxEpisodeType): Episode;
export function creatorEntityStore(kuxAsset: KuxSeriesType): Series;
export function creatorEntityStore(kuxAsset: KuxMediaAssetType): EntitiesType {
  const dmsStore = container.resolve<DmsStore>('dmsStore');
  const dms = assertPresence(dmsStore.dms);
  const linearRepository = container.resolve<LinearRepository>('linearRepository');

  switch (kuxAsset.type.toString()) {
    case dms.mediaTypes.Program: {
      const entity = new Program(kuxAsset as KuxProgramType);
      entity.init(kuxAsset as KuxProgramType);
      return entity;
    }
    case dms.mediaTypes.Linear:
      return linearRepository.getLinearById(kuxAsset.id)!;
    case dms.mediaTypes.in_application_link_asset:
      return new LinkAsAsset(kuxAsset as KuxLinkAsAssetType);
    case dms.mediaTypes.Movie:
      return new Movie(kuxAsset as KuxMovieType);
    case dms.mediaTypes.Episode:
      return new Episode(kuxAsset as KuxEpisodeType);
    case dms.mediaTypes.Series:
      return new Series(kuxAsset as KuxSeriesType);
    case dms.mediaTypes.Person:
      return new Person(kuxAsset as KuxPerson);
    case dms.mediaTypes.Logo:
      return new Logo(kuxAsset as KuxLogo);
    default:
      throw new Error(`${kuxAsset.type.toString()} - wrong entity`);
  }
}

export const createPackageEntity = (kuxAsset: KuxPackage): Package => {
  return new Package(kuxAsset);
};

export const getLinearByAssetId = async (assetId: number[]): Promise<Linear[] | undefined> => {
  if (!assetId) {
    return;
  }
  const assets = await lastValueFrom(getLinearById(assetId));
  return assets
    .map((asset) => {
      if (asset) {
        return creatorEntityStore(asset);
      }
    })
    .filter(Boolean) as Linear[];
};
